import Cookies from 'js-cookie'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import http from '@common/oneclub/services/http'
import { PERSONAL_TYPE } from '@common/oneclub/constants/userType'
import { getLanguageList } from '@common/oneclub/hooks/useLanguage'
import type { AppDispatch, AppThunkDispatch } from '@common/oneclub/store'
import type * as Types from './types'

const initialState: Types.UserInitState = {
  isLogined: !!Cookies.get('osudb_uid'),
  osudb_uid: Cookies.get('osudb_uid') || '',
  osudb_subappid: Cookies.get('osudb_subappid') || '',
  languageList: [],
  adminTicket: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLogin(state, action: PayloadAction<Types.UserState>) {
      return {
        ...state,
        isLogined: action.payload.isLogined,
        osudb_uid: action.payload.osudb_uid,
      }
    },
    setUserInfo(state, action: PayloadAction<Types.UserInfo>) {
      const newState = {
        ...state,
        info: {
          ...action.payload,
        },
      }

      return newState
    },
    setLanguageList(state, action: PayloadAction<Types.UserInitState['languageList']>) {
      return {
        ...state,
        languageList: action.payload,
      }
    },
    /** 保存超管登录ticket */
    setAdminTicket(state, action: PayloadAction<string>) {
      return {
        ...state,
        adminTicket: action.payload,
      }
    },
  },
})

/** 获取用户信息 */
export const getUserInfo = () => async (dispatch: AppThunkDispatch) => {
  const { data: userInfo } = await http.normal.post<Types.UserInfo>('/api/user/info/get-seller-basic')
  const { countryCode, userType } = userInfo || {}

  /** 是否为个人用户 */
  const isPersonal = userType === PERSONAL_TYPE
  dispatch(
    userSlice.actions.setUserInfo({
      ...userInfo,
      isPersonal,
    })
  )

  dispatch(setLanguageList(getLanguageList(countryCode)))
  return userInfo
}

/** 登出 */
export const logout = () => async (dispatch: AppDispatch) => {
  const response = await http.udb.get('/udb/lgn/login/logout.do', {
    params: {
      subappid: process.env.SUB_APPID,
      appid: process.env.APPID,
    },
  })

  const { rescode } = response
  if (rescode === '0') {
    Cookies.remove('authorization')
    dispatch(userSlice.actions.setLogin({ isLogined: false, osudb_uid: '', osudb_subappid: '' }))
    return Promise.resolve(response)
  }

  return Promise.reject(response)
}

export const { setUserInfo, setLanguageList, setAdminTicket } = userSlice.actions
export default userSlice.reducer
